import pick from 'lodash/pick';
import cloneDeep from 'lodash/cloneDeep';

const FILTER_KEYS = [
  'query', 'date_type', 'period_start', 'period_end', 'periods', 'filter_type',
  'filter_agent_id', 'attribute', 'attributes', 'channel', 'segments', 'profile_field',
  'teams', 'tags', 'views', 'team_ids', 'agent_ids', 'primary_agent_ids',
];
const NUMERIC_ARRAY_KEYS = ['teams', 'team_ids', 'agent_ids', 'primary_agent_ids'];

export function bulkActionsEnabled(context) {
  return !!context.rootState?.featureFlags?.FEATURE_FLAGS?.BULK_ASYNC_ACTIONS;
}

export function buildCustomerSelection(context, customers, selection) {
  if (!bulkActionsEnabled(context)) return { customers: customers.map(c => ({ id: c.id })) };
  if (selection?.mode !== 'all') {
    return { selection: { mode: 'explicit' }, customers: customers.map(c => ({ id: Number(c.id) })) };
  }
  if (!selection.filters) throw new Error('All-results selection requires filters');
  const filters = cloneDeep(pick(selection.filters, FILTER_KEYS));
  filters.views = cloneDeep(context.rootGetters['agent/customersDashboardViews']);
  NUMERIC_ARRAY_KEYS.forEach(key => {
    if (filters[key]) filters[key] = filters[key].map(Number);
  });
  if (filters.filter_agent_id !== undefined && filters.filter_agent_id !== null) filters.filter_agent_id = Number(filters.filter_agent_id);
  ['segments', 'tags'].forEach(key => {
    if (filters[key]) filters[key] = filters[key].map(String);
  });
  if (typeof filters.periods === 'string') filters.periods = JSON.parse(filters.periods);
  return { selection: { mode: 'all', filters } };
}
